export default "__VITE_ASSET__Do_Guk5I__"